import * as Sentry from '@sentry/nextjs';
import {isAxiosError} from 'axios';
import {isDev} from 'config';
import {ICustomerResponse} from 'types';

class LoggerService {
  updateUser = (user: ICustomerResponse) => {
    if (user.id) {
      const sentryUser = {...user};
      Sentry.setUser(sentryUser);
    } else {
      Sentry.setUser(null);
    }
  };

  setContext = (key: string, data: {[key: string]: any}) => {
    if (!key || !data) return;
    Sentry.setContext(key, data);
  };

  logDebug(message: any, category?: string) {
    const cat = category ? category : '';
    if (isDev) console.log(`DEBUG: ${cat}`, message);
  }

  error(e: Error, data?: any) {
    const isAxiosErr = isAxiosError(e);

    if (isDev) {
      // eslint-disable-next-line no-console
      console.log('ERROR', `${JSON.stringify(e)}`, data);
    }

    if (isAxiosErr && e.response?.status) {
      Sentry.setTag('method', e.response.status);
      if (e.response.status == 404) {
        Sentry.setExtra('infoConfig', e?.response?.config);
        Sentry.setExtra('infoData', e?.response?.data);
        // disable logging for specific URLs restaurant that disabled or hidden
        //  ex: https://straus.md/ru/restaurant/momo-asian-bar
        if (e?.response?.config.url && '/restaurants/'.includes(e?.response?.config.url)) return;
        return Sentry.captureMessage('Request ------ 404');
      }
      if (e.response.status == 500) {
        Sentry.setExtra('info', e?.response?.config);
        return Sentry.captureMessage('Request ------ 500');
      }
      if (e.response?.status == 400 || e.response?.status == 405) {
        if (e.config?.url && ['/login', '/logout'].includes(e?.config?.url)) return;
        Sentry.setExtra('request', e?.request);
        Sentry.setExtra('response', e?.response);
        return Sentry.captureMessage('Req error: 400-405');
      }
    }
    Sentry.captureException(e, {data});
  }

  addBreadcrumb(message: string, data: {[key: string]: any}) {
    this.logDebug(data, 'Logger[addBreadcrumb]');
    Sentry.addBreadcrumb({
      type: 'default',
      category: 'info',
      message,
      data: data,
    });
  }
}

const logger = new LoggerService();
export default logger;
